import { IAlert } from 'app/shared/model/alert.model';
import { ICompany } from 'app/shared/model/company.model';

export interface ITruckGroup {
  id?: number;
  name?: string;
  description?: string | null;
  isDefault?: boolean;
  activated?: boolean;
  createdDate?: string | null;
  company?: ICompany | null;
  alerts?: IAlert[];
  truckIds?: number[];
  truckCount?: number | null;
  virtualFenceIds?: number[] | null;
  virtualFenceCount?: number | null;
}

export interface ITruckGroupListDTO {
  id?: number;
  name?: string;
  description?: string | null;
  isDefault?: boolean;
  activated?: boolean;
  alertCount?: number | null;
  truckCount?: number | null;
  virtualFenceCount?: number | null;
  companyId?: number | null;
  companyName?: string | null;
  hasPendingFences?: boolean | null;
}

export const defaultValue: Readonly<ITruckGroup> = {
  isDefault: false,
  activated: true,
  alerts: [],
};
